import Vue from 'vue';
import Router from 'vue-router';

const HomePage = () => import('@/pages/HomePage.vue');
const CreateProfilePage = () => import('@/pages/CreateProfilePage.vue');
const CreateProfileConsentPage = () => import('@/pages/CreateProfileConsentPage.vue');
const EditProfilePage = () => import('@/pages/EditProfilePage.vue');
const ListSharesPage = () => import('@/pages/ListSharesPage.vue');
const CreateSharePage = () => import('@/pages/CreateSharePage.vue');
const ChooseUploadScanPage = () => import('@/pages/ChooseUploadScanPage.vue');
const UploadScanPage = () => import('@/pages/UploadScanPage.vue');
const ListScansPage = () => import('@/pages/ListScansPage.vue');
const BrainPage = () => import('@/pages/BrainPage.vue');
const ResetPasswordPage = () => import('@/pages/ResetPasswordPage.vue');
const ForgotPasswordPage = () => import('@/pages/ForgotPasswordPage.vue');

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage,
    },
    {
      path: '/profile/new',
      name: 'createProfile',
      component: CreateProfilePage,
    },
    {
      path: '/profile/new/consent',
      name: 'createProfileConsent',
      component: CreateProfileConsentPage,
    },
    {
      path: '/profile/edit',
      name: 'editProfile',
      component: EditProfilePage,
    },
    {
      path: '/profile/share',
      name: 'listShares',
      component: ListSharesPage,
    },
    {
      path: '/profile/share/new',
      name: 'createShare',
      component: CreateSharePage,
    },
    {
      path: '/scan/upload/choose',
      name: 'chooseUploadScan',
      component: ChooseUploadScanPage,
    },
    {
      path: '/scan/upload',
      name: 'uploadScan',
      component: UploadScanPage,
    },
    {
      path: '/scan/list',
      name: 'listScans',
      component: ListScansPage,
    },
    {
      path: '/scan/:scanId/render/:viewType',
      name: 'renderScan',
      component: BrainPage,
      props: (route) => ({
        scanId: Number.parseInt(route.params.scanId, 10),
        viewType: route.params.viewType,
      }),
    },
    {
      path: '/brain/:view_type',
      name: 'brain',
      component: BrainPage,
    },
    {
      path: '/reset-password/:uid/:token',
      name: 'resetPassword',
      component: ResetPasswordPage,
    },
    {
      path: '/forgot-password',
      name: 'forgotPassword',
      component: ForgotPasswordPage,
    },
  ],
});
